(function() {
  let pendingVariantId = null;
  let rerenderTimer = null;

  function getVariantIdFrom(eTarget) {
    if (!eTarget) return null;
    if (eTarget.name === 'id' && eTarget.value) return eTarget.value;

    const form = eTarget.closest('form') || document;
    const select = form.querySelector('select[name="id"]');
    if (select && select.value) return select.value;

    const checked = form.querySelector('input[name="id"]:checked');
    return checked ? checked.value : null;
  }

  function queuePricingRefresh(variantId) {
    if (!variantId) return;

    pendingVariantId = String(variantId);

    if (rerenderTimer !== null) {
      window.clearTimeout(rerenderTimer);
    }

    // Let Empire's variant-selection controls finish syncing the hidden ID input
    // before we fetch the section-rendered pricing fragment.
    rerenderTimer = window.setTimeout(function() {
      const nextVariantId = pendingVariantId;
      pendingVariantId = null;
      rerenderTimer = null;
      rerenderPricing(nextVariantId);
    }, 60);
  }

  async function rerenderPricing(variantId) {
    const root = document.querySelector('article.product--outer');
    const pricing = document.querySelector('[data-product-pricing]');
    if (!root || !pricing || !variantId) return;

    const sectionId = root.getAttribute('data-section-id');
    const productUrl = root.getAttribute('data-product-url') || window.location.pathname;
    const url = `${productUrl}?section_id=${encodeURIComponent(sectionId)}&variant=${encodeURIComponent(variantId)}`;

    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newPricing = doc.querySelector('[data-product-pricing]');
      if (newPricing) {
        pricing.innerHTML = newPricing.innerHTML;
      }

      const currentSku = document.querySelector('.product-sku');
      const newSku = doc.querySelector('.product-sku');
      if (currentSku && newSku) currentSku.innerHTML = newSku.innerHTML;

      const currentUnit = document.querySelector('[data-unit-price]');
      const newUnit = doc.querySelector('[data-unit-price]');
      if (currentUnit && newUnit) currentUnit.outerHTML = newUnit.outerHTML;

      const currentTax = document.querySelector('[data-tax-line]');
      const newTax = doc.querySelector('[data-tax-line]');
      if (currentTax && newTax) currentTax.outerHTML = newTax.outerHTML;
    } catch (err) {
      console.warn('Section render failed; no pricing update', err);
    }
  }

  document.addEventListener('change', function(e) {
    queuePricingRefresh(getVariantIdFrom(e.target));
  });

  document.addEventListener('variant:change', function(e) {
    const v = e.detail?.variant?.id || e.detail?.variantId;
    queuePricingRefresh(v);
  });

  document.addEventListener('product:variant-change', function(e) {
    const v = e.detail?.variant?.id || e.detail?.variantId;
    queuePricingRefresh(v);
  });

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('variant-selection[data-variant-selection]').forEach(function(selection) {
      selection.addEventListener('variant-change', function(e) {
        const v = e.detail?.variant?.id;
        queuePricingRefresh(v);
      });
    });

    const preset = new URLSearchParams(window.location.search).get('variant');
    if (preset) queuePricingRefresh(preset);
  });
})();
